import { apiRequest } from '@peruselab/api-client/httpRequest';
import type { Gene } from './Gene';

export async function getGene(id: string): Promise<Gene> {
  return apiRequest<Gene>(`/genes/${encodeURIComponent(id)}`, 'gene');
}
